<template>
  <div>
    <template v-if="project">
      <ugi-main-section :showPagination="true">
        <ul class="divide-y divide-gray-200">
          <client-projects-edit-proposals-list-item v-for="company in surveyCompaniesWithProposals" :key="company.id" :project.sync="projectInternal" :surveyCompany="company" />
        </ul>
        <div v-if="surveyCompaniesWithProposals !== null && surveyCompaniesWithProposals.length === 0">
          <p class="ugi-empty-list-legend" >{{ $t('No proposals have been submitted yet') }}</p>
        </div>
      </ugi-main-section>
    </template>
    <div>
      <p class="max-w-3xl mt-4 mx-auto text-center text-xl leading-9 font-medium text-gray-500">
        {{$t(currentError)}}
      </p>
    </div>
  </div>
</template>

<script>
import ClientProjectsEditProposalsListItem from "./ClientProjectsEditProposalsListItem.vue";
import { HTTP } from "@/http.js";

export default {
  props: {
    project: {
      type: Object
    }
  },
  components:
      {
        ClientProjectsEditProposalsListItem
      },
  data ()
  {
    return {
      surveyCompaniesWithProposals: null,
      currentError: ""
    };
  },
  computed:
      {
        projectInternal: {
          get ()
          {
            return this.project;
          },
          set (value)
          {
            this.$emit("update:project", value);
          }
        }
      },
  mounted ()
  {
    HTTP.get("/survey-companies")
      .then(response =>
      {
        this.surveyCompaniesWithProposals = [];
        response.forEach(company =>
        {
          if (this.project.applications.some(application => application.idSurveyCompany === company.id && application.proposals.some(proposal => proposal.type !== "INVITE")))
          {
            this.surveyCompaniesWithProposals.push(company);
          }
        });
      })
      .catch(error =>
      {
        this.currentError = error;
      });
  },
  methods: {

  },
  watch: {

  }
};
</script>
